import { opportunitySyncProfilesService } from '@/services/opportunity-sync-profiles.service';
import axios from 'axios';

const initialState = () => ({
  suggestedAccounts: [],
  accountManualSearchResults: [],
  status: {
    error: null,
    pending: false,
    pendingAddAccount: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  getSuggestedAccounts({ commit }, { syncProfileId, searchQuery }) {
    commit('GET_SUGGESTED_ACCOUNTS');
    return opportunitySyncProfilesService.searchAccount({ syncProfileId, searchQuery }).then(
      (response) => {
        return commit('SUCCESS_GET_SUGGESTED_ACCOUNTS', response);
      },
      (error) => {
        if (!axios.isCancel(error)) {
          // commit('ERROR_GET_OPPORTUNITY_SYNC_PROFILES', error);
          throw error;
        }
      },
    );
  },
  searchAccounts({ commit }, { syncProfileId, searchQuery }) {
    commit('SEARCH_ACCOUNTS');
    return opportunitySyncProfilesService.searchAccount({ syncProfileId, searchQuery }).then(
      (response) => {
        commit('SUCCESS_SEARCH_ACCOUNTS', response);
        return response;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          throw error;
        }
      },
    );
  },
  addAccount({ commit }, { syncProfileId, name }) {
    commit('ADD_ACCOUNT');
    return opportunitySyncProfilesService.addAccount({ syncProfileId, name }).then(
      (account) => {
        commit('ADD_ACCOUNT_SUCCESS', account);
        return account;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          throw error;
        }
      },
    );
  },
  searchUser({ commit }, { syncProfileId, searchQuery }) {
    return opportunitySyncProfilesService.searchUser({ syncProfileId, searchQuery }).then(
      (response) => {
        return response;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          throw error;
        }
      },
    );
  },
};

const mutations = {
  GET_SUGGESTED_ACCOUNTS(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
    state.suggestedAccounts = [];
    state.accountManualSearchResults = [];
    state.similarOpportunities = [];
  },
  SUCCESS_GET_SUGGESTED_ACCOUNTS(state, accounts) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
    state.suggestedAccounts = accounts;
  },
  SEARCH_ACCOUNTS(state) {
    state.status = {
      error: null,
      pending: false,
      resolved: false,
      rejected: false,
    };
    state.accountManualSearchResults = [];
  },
  SUCCESS_SEARCH_ACCOUNTS(state, results) {
    state.status = {
      ...state.status,
      resolved: true,
    };
    state.accountManualSearchResults = results;
  },
  ADD_ACCOUNT(state) {
    state.status = {
      pendingAddAccount: true,
    };
  },
  ADD_ACCOUNT_SUCCESS(state, account) {
    state.status = {
      pendingAddAccount: false,
    };
    state.suggestedAccounts.push(account);
  },
  ERROR(state, error) {
    state.status = {
      error,
      pending: false,
      resolved: false,
      rejected: true,
    };
  },
};

const getters = {
  suggestedAccounts: (state) => state.suggestedAccounts,
  accountManualSearchResults: (state) => state.accountManualSearchResults,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  pendingAddAccount: (state) => state.status.pendingAddAccount,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const opportunitySyncProfileAccounts = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
